class DashboardTexts {
  search = "جستجو";
  userInfo = "اطلاعات کاربر";
  services = "سرویس‌ها";
  lines = "خط‌ها";
  transactions = "تراکنش‌ها";
  userAuth = "احراز هویت";
  activateLines = "فعالسازی خطوط";
  rejectedLines = "خطوط رد شده";
  promotions = "کد‌های تخفیف";
  back = "بازگشت";
  setting = "تنظیمات";
  changeEmail = "تغییر ایمیل‌ها"
  accounting = "حسابداری"
  outPut = "خروجی نرم‌افزار"
  invoice = "فاکتور‌ها"
  activities = "فعالیت کاربران"
  calendarSettings = "تنظیمات تقویم"
  activePackage="بسته‌های فعال"
  restrictedCall="ویترین خطوط"
  SensitiveWords="فعالیت‌های حساس"
  Customertracking="ردیابی مشترکین"
  sensitiveWord="کلمات حساس"
}
export default new DashboardTexts();
